import MissionGroupCard from './MissionGroupCard';

export default MissionGroupCard;
